import styled from 'styled-components'

interface CircleColorProps {
  color: string
}

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center; 
  margin-bottom: 10px;
`

export const CircleColor = styled.div<CircleColorProps>`
  background-color: ${({ color }) => color};
  border-radius: 50%;
  height: 15px;
  margin-right: 10px;
  width: 15px;
`